
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.563 0H8.438A8.402 8.402 0 000 8.438v13.124A8.402 8.402 0 008.438 30h13.124A8.402 8.402 0 0030 21.562V8.438A8.402 8.402 0 0021.562 0z","fill":"#1AB7EA"}}),_c('path',{attrs:{"d":"M21.374 20.156c-3.093 4.125-5.718 6.094-8.062 6.094-1.688 0-3-1.406-4.031-4.125l-1.782-6.469c-.468-1.875-.937-2.53-1.125-2.718-.187.093-.562.375-1.125.75-.375.28-1.03.187-1.312-.188l-.938-1.312c-.28-.375-.28-.938.094-1.22l3.094-2.812c1.594-1.5 2.625-2.437 3.656-2.53 1.031-.095 3.469.093 4.125 4.5.469 3.28.75 4.405.844 4.874.281 1.406.562 2.156.75 2.438.187-.188.562-.657 1.125-1.5 1.031-1.594 1.219-2.438 1.312-2.813.094-.469 0-.656-.093-.75 0 0-.188-.094-.375-.094-.375 0-.75.094-1.22.282-.374.187-.75.093-1.03-.188-.282-.281-.375-.656-.282-.937 1.22-3.938 3.375-5.813 6.75-5.72 1.22 0 2.344.563 3.188 1.407.937 1.031 1.406 2.531 1.406 4.219-.187 2.344-2.062 4.875-4.969 8.812z","fill":"#fff"}})])
          )
        }
      }
    